import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import auth from './auth.store';
import draft from './draft';
import global from './global.store';
import lists from './lists.store';
import rankings from './rankings.store';

Vue.use(Vuex);

const vuexPersistPathsWhiteList = [
  'draft.seenDraftBoardHelp',
];

export default new Vuex.Store({
  modules: {
    auth,
    draft,
    global,
    lists,
    rankings,
  },
  plugins: [
    createPersistedState({
      key: '1st-5-draft',
      paths: vuexPersistPathsWhiteList,
    }),
  ],
});
